(function () {
  'use strict';
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  var section = document.querySelector('.aj');
  if (!section) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var isMobile = window.innerWidth < 768;

  // Mobile: IntersectionObserver scroll reveal, no GSAP
  if (isMobile) {
    var mobileTiles = Array.from(section.querySelectorAll('.aj-tile'));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    mobileTiles.forEach(function (tile) { io.observe(tile); });
    return;
  }

  var tiles    = Array.from(section.querySelectorAll('.aj-tile'));
  var fill     = section.querySelector('.aj-timeline-fill');
  var dots     = Array.from(section.querySelectorAll('.aj-timeline-dot'));

  // ── Cache DOM references at init (never query inside animation loop) ──
  var visual1  = section.querySelector('[data-visual="1"]');
  var visual2  = section.querySelector('[data-visual="2"]');
  var visual3  = section.querySelector('[data-visual="3"]');
  var visual4  = section.querySelector('[data-visual="4"]');

  var v1items  = visual1 ? Array.from(visual1.querySelectorAll('.aj-v1-item')) : [];
  var v1checks = v1items.map(function (el) { return el.querySelector('.aj-v1-check'); });
  var v1item2  = visual1 ? visual1.querySelector('[data-item="2"]') : null;

  var v2cards  = visual2 ? Array.from(visual2.querySelectorAll('.aj-v2-card')) : [];
  var v2rot    = v2cards.map(function (c) { return c.style.getPropertyValue('--r') || '0deg'; });

  var v3typed  = visual3 ? visual3.querySelector('.aj-v3-typed')    : null;
  var v3cursor = visual3 ? visual3.querySelector('.aj-v3-cursor')   : null;
  var v3render = visual3 ? visual3.querySelector('.aj-v3-render')   : null;
  var v3surf   = visual3 ? visual3.querySelector('.aj-code-surface'): null;
  var v3str    = v3typed ? (v3typed.getAttribute('data-code') || '') : '';

  var v4cards  = visual4 ? Array.from(visual4.querySelectorAll('.aj-v4-card')) : [];
  var v4rot    = v4cards.map(function (c) { return c.style.getPropertyValue('--r') || '0deg'; });

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }
  function lerp(a, b, t)    { return a + (b - a) * t; }
  function ss(t)             { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); }
  function phaseFrac(p, a, b){ return ss(clamp((p - a) / (b - a), 0, 1)); }

  function activeStep(p) {
    if (p < 0.15) return 0;
    if (p < 0.35) return 1;
    if (p < 0.55) return 2;
    if (p < 0.75) return 3;
    return 4;
  }

  // ── Tile 1 ──
  function animateTile1(t) {
    v1items.forEach(function (item, i) {
      var it = phaseFrac(t, i * 0.18, i * 0.18 + 0.38);
      item.style.opacity = it;
      if (!item.classList.contains('is-active')) {
        item.style.transform = 'translate3d(' + lerp(-10, 0, it) + 'px,0,0)';
      }
      var check = v1checks[i];
      if (check) check.classList.toggle('is-checked', t > (0.12 + i * 0.18 + 0.42));
    });
    if (v1item2) v1item2.classList.toggle('is-active', t >= 0.5 && t <= 0.9);
  }

  // ── Tile 2 ──
  function animateTile2(t) {
    v2cards.forEach(function (card, i) {
      var ct = phaseFrac(t, i * 0.13, i * 0.13 + 0.38);
      card.style.opacity   = ct;
      card.style.transform = 'translate3d(0,' + lerp(14, 0, ct) + 'px,0) rotate(' + v2rot[i] + ') scale(' + lerp(0.88, 1, ct) + ')';
    });
  }

  // ── Tile 3 ──
  function animateTile3(t) {
    if (isMobile) {
      if (v3surf)   v3surf.style.opacity = 0;
      if (v3render) { v3render.style.opacity = 1; v3render.style.transform = 'none'; }
      return;
    }
    if (v3typed) {
      var count = Math.floor(phaseFrac(t, 0, 0.65) * v3str.length);
      if (count !== prev.count) {
        v3typed.textContent = v3str.slice(0, count);
        prev.count = count;
      }
      if (v3cursor) v3cursor.style.opacity = t < 0.65 ? 1 : 0;
    }
    var CROSS = 0.70;
    if (t < CROSS) {
      if (v3surf && v3prevSurfOpacity !== 1)        { v3surf.style.opacity = 1;   v3surf.style.transform = 'translate3d(0,0,0)'; v3prevSurfOpacity = 1; }
      if (v3render && v3prevRenderOpacity !== 0)    { v3render.style.opacity = 0; v3render.style.transform = 'translate3d(0,20px,0)'; v3prevRenderOpacity = 0; }
    } else {
      var ct = clamp((t - CROSS) / (1 - CROSS), 0, 1);
      if (v3surf)   { v3surf.style.opacity = 1 - ct; v3surf.style.transform = 'translate3d(0,' + (-20 * ct) + 'px,0)'; v3prevSurfOpacity = 1 - ct; }
      if (v3render) {
        var rt = clamp((ct - 0.2) / 0.8, 0, 1);
        v3render.style.opacity   = rt;
        v3render.style.transform = 'translate3d(0,' + lerp(20, 0, rt) + 'px,0)';
        v3prevRenderOpacity = rt;
      }
    }
  }

  // ── Tile 4 ──
  function animateTile4(t) {
    v4cards.forEach(function (card, i) {
      var ct = phaseFrac(t, i * 0.20, i * 0.20 + 0.38);
      card.style.opacity   = ct;
      card.style.transform = 'translate3d(0,' + lerp(14, 0, ct) + 'px,0) rotate(' + v4rot[i] + ') scale(' + lerp(0.88, 1, ct) + ')';
    });
  }

  var N = tiles.length; // 4

  // ── State cache : skip identical writes between frames ──
  var prev = { p: -1, step: -1, count: -1, fillW: -1 };
  var v3prevSurfOpacity = -1, v3prevRenderOpacity = -1;

  // ── Main render ──
  function render(p) {
    if (Math.abs(p - prev.p) < 0.0008) return;
    prev.p = p;

    var fillW = Math.round(p * 1000) / 10;
    if (fill && fillW !== prev.fillW) {
      fill.style.width = fillW + '%';
      prev.fillW = fillW;
    }

    var step = activeStep(p);
    if (step !== prev.step) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i + 1 === step);
        d.classList.toggle('is-past',   i + 1 < step);
      });
      if (!isMobile) {
        tiles.forEach(function (tile, i) {
          tile.classList.toggle('is-active', i + 1 === step);
        });
      }
      prev.step = step;
    }

    if (isMobile) {
      tiles.forEach(function (tile, i) {
        var offset = i / (N - 1);
        var rawY   = clamp((offset - p) * (N - 1), -1, 1);
        tile.style.transform = 'translate3d(0,' + (rawY * 100) + '%,0)';
        tile.style.opacity = String(lerp(0.55, 1, clamp(1 - Math.abs(rawY), 0, 1)));
        var lp = clamp((p - offset + 1 / (N - 1)) * (N - 1), 0, 1);
        if (i === 0) animateTile1(lp);
        else if (i === 1) animateTile2(lp);
        else if (i === 2) animateTile3(lp);
        else if (i === 3) animateTile4(lp);
      });
      return;
    }

    animateTile1(phaseFrac(p, 0.15, 0.35));
    animateTile2(phaseFrac(p, 0.35, 0.55));
    animateTile3(phaseFrac(p, 0.55, 0.75));
    animateTile4(phaseFrac(p, 0.75, 1.00));
  }

  // ── ScrollTrigger ──
  render(0);

  /* Pas de pin : on laisse la section scroller naturellement. Le render(progress)
     joue pendant que la section traverse le viewport (top 80% → bottom 20%).
     Évite les conflits avec le pin de cinematic-hero juste avant. */
  ScrollTrigger.create({
    trigger: section,
    start: 'top 80%',
    end: 'bottom 20%',
    scrub: isMobile ? true : 0.6,
    onUpdate: function (self) { render(self.progress); },
    onRefresh: function (self) { render(self.progress); }
  });

  window.addEventListener('load', function () {
    ScrollTrigger.refresh();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth < 768) {
      // Kill everything if resized to mobile (e.g. DevTools responsive mode)
      ScrollTrigger.getAll().forEach(function (st) { st.kill(); });
      tiles.forEach(function (t) { t.style.transform = ''; t.style.opacity = ''; });
      return;
    }
    isMobile = false;
    ScrollTrigger.refresh();
  });
})();
